export const SIGN_IN_ROUTE = {
  name: 'sign_in',
  path: '/sign-in',
};

export const SIGN_UP_ROUTE = {
  name: 'sign_up',
  path: '/sign-up',
};

export const AUTH_ROUTE = {
  name: 'auth',
  path: '/auth',
};

export const EMAIL_CONFIRMATION_ROUTE = {
  name: 'email_confirmation',
  path: '/email-confirmation',
};

export const DOWNLOAD_ROUTE = {
  name: 'download',
  path: '/download',
};
export const PUBLIC_DOWNLOAD_ROUTE = {
  name: 'public-download',
  path: '/public-download',
};

export const RESET_PASSWORD_ROUTE = {
  name: 'reset_password',
  path: '/reset-password',
};

export const RESET_PASSWORD_CONFIRM_ROUTE = {
  name: 'reset_password_confirm',
  path: '/reset-password/:id',
};

// V2 Routes for A/B testing
export const SIGN_IN_ROUTE_V2 = {
  name: 'sign_in_v2',
  path: '/v2/sign-in',
};

export const SIGN_UP_ROUTE_V2 = {
  name: 'sign_up_v2',
  path: '/v2/sign-up',
};

export const AUTH_ROUTE_V2 = {
  name: 'auth_v2',
  path: '/v2/auth',
};

export const EMAIL_CONFIRMATION_ROUTE_V2 = {
  name: 'email_confirmation_v2',
  path: '/v2/email-confirmation',
};

export const DOWNLOAD_ROUTE_V2 = {
  name: 'download_v2',
  path: '/v2/download',
};

export const PUBLIC_DOWNLOAD_ROUTE_V2 = {
  name: 'public-download_v2',
  path: '/v2/public-download',
};

export const RESET_PASSWORD_ROUTE_V2 = {
  name: 'reset_password_v2',
  path: '/v2/reset-password',
};

export const RESET_PASSWORD_CONFIRM_ROUTE_V2 = {
  name: 'reset_password_confirm_v2',
  path: '/v2/reset-password/:id',
};

export const privateRouteNames = [
  DOWNLOAD_ROUTE.name,
  DOWNLOAD_ROUTE_V2.name,
];

export const authRouteNames = [
  RESET_PASSWORD_ROUTE.name,
  RESET_PASSWORD_ROUTE_V2.name,

  RESET_PASSWORD_CONFIRM_ROUTE.name,
  RESET_PASSWORD_CONFIRM_ROUTE_V2.name,

  EMAIL_CONFIRMATION_ROUTE.name,
  EMAIL_CONFIRMATION_ROUTE_V2.name,

  AUTH_ROUTE.name,
  AUTH_ROUTE_V2.name,

  SIGN_UP_ROUTE.name,
  SIGN_UP_ROUTE_V2.name,

  SIGN_IN_ROUTE.name,
  SIGN_IN_ROUTE_V2.name,
];